import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { CfAsset } from '../asset';
import { mapCfEntityToCfProductAccessory } from './mapper';

export class CfProductAccessory {
    static contentType = contentTypes.CfProductAccessory;

    static mapCfEntity = mapCfEntityToCfProductAccessory;

    constructor(data) {
        this.description = data.description;
        this.title = data.title;
        this.image = data.image && new CfAsset(data.image);
    }
}
